import {RefererName} from '@widgets/hroc-checklists'

export const FEATURE_NAMESPACE = 'feature.hroc-checklists'

export const ChecklistRefererLabelKeyMap: Record<RefererName, string> = {
  [RefererName.Tasks]: 'referer.tasks',
  [RefererName.ChecklistTemplates]: 'referer.checklistTemplates'
}
